import React, { useCallback, useContext } from 'react'
import styled from 'styled-components'
import OfferDatePickerSelectBox from './OfferDatePickerSelectBox'
import { rem } from 'polished'
import OfferDatePicker from './OfferDatePicker'
import { CALENDAR_GA_EVENT_ACTION, CALENDAR_GA_EVENT_LABEL } from 'constants/analytics'
import OfferFilterFullSizeDropdown from 'components/OfferPage/Filters/OfferFilterFullSizeDropdown'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import TextButton from 'components/Luxkit/Button/TextButton'
import UserAnalyticsActionContext from 'contexts/userAnalyticsActionContext'

const DatePickerContainer = styled.div`
  padding: ${rem(24)};
  padding-top: ${rem(48)};
`

const ApplySection = styled.div`
  background-color: ${props => props.theme.palette.neutral.default.eight};
  display: flex;
  justify-content: flex-end;
  padding: ${rem(12)} ${rem(40)};
  border-top: 1px solid ${props => props.theme.palette.neutral.default.five};
`

interface Props {
  open: boolean;
  offsetDropdown?: boolean;
}

function OfferDatePickerSelect({
  open,
  offsetDropdown,
}: Props) {
  const dispatch = useOfferPageDispatch()
  const onUserAnalyticsAction = useContext(UserAnalyticsActionContext)

  const onCloseCross = useCallback(() => {
    onUserAnalyticsAction?.(CALENDAR_GA_EVENT_ACTION.CloseFilter, CALENDAR_GA_EVENT_LABEL.CloseCross)
    dispatch({ type: OfferPageActions.closeFilter })
  }, [dispatch, onUserAnalyticsAction])

  const onApply = useCallback(() => {
    onUserAnalyticsAction?.(CALENDAR_GA_EVENT_ACTION.Apply)
    dispatch({ type: OfferPageActions.closeFilter })
  }, [dispatch, onUserAnalyticsAction])

  return (<div>
    <OfferDatePickerSelectBox />
    <OfferFilterFullSizeDropdown
      onClose={onCloseCross}
      open={open}
      offset={offsetDropdown}
      data-testid="OfferDatePickerSelect"
    >
      <DatePickerContainer>
        <OfferDatePicker />
      </DatePickerContainer>
      <ApplySection>
        <TextButton
          kind="primary"
          data-testid="OfferDatePickerSelect-apply"
          onClick={onApply}
        >
          Apply
        </TextButton>
      </ApplySection>
    </OfferFilterFullSizeDropdown>
  </div>
  )
}

export default withOfferPageState(state => ({
  open: state.activeFilter === 'datepicker',
}))(OfferDatePickerSelect)
